import * as React from 'react';
import Icon from '../Icon';
import {PropsWithChildren, useEffect, useState} from 'react';
import classNames from 'classnames';

export interface INestedMenuItemHeaderProps extends PropsWithChildren {
    /** Opened submenu */
    open?: string;
    /** Submenu toggling */
    setOpenSubMenu?: (id) => void;
    /** ID */
    id?: string;
    className?: string;
    link?: string;
    hasOpenSubMenu?: boolean;
    /** Labels to use when submenu open */
    labelBack: string;
    labelViewAll: string;
    /** Is open by default */
    isDefaultOpen: boolean;
    /** Is active menu items */
    isActive: boolean;
    children?: React.ReactNode;
}

const NestedMenuItemHeader: React.FunctionComponent<INestedMenuItemHeaderProps> = (props) => {
    const [inited, setInited] = useState(false);
    useEffect(() => {
        if (props.isDefaultOpen && !inited && props.setOpenSubMenu) {
            props.setOpenSubMenu(props.id);
            setInited(true);
        }
    }, [props.id]);

    return props.open===undefined || !props.open ? (
        <a className={classNames('nested-menu__toggler',props.isActive && 'active')} aria-current={props.isActive} data-id={props.id} href={props.link ? props.link : '#'} onClick={(e) => { if(props.setOpenSubMenu) { e.preventDefault(); props.setOpenSubMenu(props.id); }}}>
            <span>{props.children}</span>
            <Icon
                kind="arrow5-right"
                width={16}
                height={16}
            />
        </a>
    ) : (
        <React.Fragment>
            {
                props.open === props.id && !props.hasOpenSubMenu && (
                    <React.Fragment>
                        <button className="nested-menu__back" onClick={() => {
                            if (props.setOpenSubMenu) {
                                props.setOpenSubMenu(null);
                            }
                        }}>
                            <Icon
                                kind="arrow4-left"
                                width={24}
                                height={24}
                            />
                            {props.labelBack}
                        </button>
                        <div className="nested-menu__heading">
                            <h2>{props.children}</h2>
                            <a href={props.link}>
                                {props.labelViewAll}
                                <Icon
                                    kind="arrow4-right"
                                    width={24}
                                    height={24}
                                />
                            </a>
                        </div>
                    </React.Fragment>
                )
            }

        </React.Fragment>
    );
};

NestedMenuItemHeader.displayName = 'NestedMenuItemHeader';

export default NestedMenuItemHeader;
